import { collection, query, orderBy, limit, getDocs } from 'firebase/firestore';
import { db } from '../shared/api/firebase/config';
import { FIREBASE_CONFIG } from '../config/Config';

const appId = FIREBASE_CONFIG.projectId;

export async function fetchExamResults(uid) {
  const resultsRef = collection(db, 'artifacts', appId, 'users', uid, 'exam_results');
  const q = query(resultsRef, orderBy('createdAt', 'desc'), limit(10));
  const snap = await getDocs(q);
  return snap.docs.map(d => d.data());
}
